const EncryptionService = {
    encrypt: encrypt,
    decrypt: decrypt,
    base64EncArr: base64EncArr,
    base64DecToArr: base64DecToArr,
};

const encoder = new TextEncoder("utf-8");
const textDecoder = new TextDecoder("utf-8");

async function viewMessage() {

    const url = new URL(window.location.href.replace("#", "?"));
    const key = url.searchParams.get("key");

    if (undefined === url.searchParams.get("uuid") || undefined === url.searchParams.get("key")) {
        return // todo error handling.
    }

    const fetchURL = BACKEND_HOST + '/message/' + url.searchParams.get("uuid");
    fetch(fetchURL, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Origin': FRONTEND_HOST
        }
    }).then(function (response) {
        response.json().then((data) => {
            decrypt(base64DecToArr(key), base64DecToArr(data.message))
                .then((plainText) => {
                    document.getElementById("message-viewer").value = plainText;
                })
        });
    });
}



/**
 *
 * @param secret
 * @param messagePlainText
 * @returns {Promise<*>} Promise resolves to an encrypted Uint8Array.
 */
async function encrypt(secret, messagePlainText) {

    const {message} = await openpgp.encrypt({
        message: openpgp.message.fromBinary(encoder.encode(messagePlainText)), // input as Message object
        passwords: [secret],                                             // multiple passwords possible
        armor: false                                                     // don't ASCII armor (for Uint8Array output)
    });
    let packets = message.packets.write(); // get raw encrypted packets as Uint8Array
    return base64EncArr(packets)
}

/**
 *
 * @param secret
 * @param encryptedMessage
 * @returns {Promise<*|string>} Promise resolves to an unencrypted Uint8Array.
 */
async function decrypt(secret, encryptedMessage) {
    encryptedMessage = base64DecToArr(encryptedMessage);
    const {data: decrypted} = await openpgp.decrypt({
        message: await openpgp.message.read(encryptedMessage), // parse encrypted bytes
        passwords: [secret],                    // decrypt with password
        format: 'binary'                                // output as Uint8Array
    });
    return textDecoder.decode(decrypted); // Uint8Array([0x01, 0x01, 0x01])
}


function createLink() {
    let messageString = document.getElementById("message-input").value;
    let secret = getSecret();

    encrypt(secret, messageString)
        .then((encryptedBytes) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", BACKEND_HOST + "/message", true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.setRequestHeader("Origin", FRONTEND_HOST);

            xhr.onreadystatechange = function () { // Call a function when the state changes.
                if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                    console.log("Request Complete!");
                    const uuidObj = JSON.parse(this.response);
                    // Generate the link and update inner html on page.
                    document.getElementById("link-text").value = FRONTEND_HOST
                        + "/view.html#"
                        + "uuid=" + uuidObj.uuid
                        + "&key=" + encodeURIComponent(base64EncArr(secret));
                } else if (this.readyState === XMLHttpRequest.DONE && this.status !== 200) {
                    console.log("Error completing request..");
                    // todo error handling
                }
            };
            xhr.send('{"message": "' + base64EncArr(encryptedBytes) + '"}');
        });
}

// Taken from https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_5_%E2%80%93_rewrite_the_DOMs_atob()_and_btoa()_using_JavaScript's_TypedArrays_and_UTF-8

"use strict";

/*\
|*|
|*|  Base64 / binary data / UTF-8 strings utilities (#2)
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
|*|
|*|  Author: madmurphy
|*|
\*/

/* Array of bytes to base64 string decoding */

function b64ToUint6(nChr) {

    return nChr > 64 && nChr < 91 ?
        nChr - 65
        : nChr > 96 && nChr < 123 ?
            nChr - 71
            : nChr > 47 && nChr < 58 ?
                nChr + 4
                : nChr === 43 ?
                    62
                    : nChr === 47 ?
                        63
                        :
                        0;

}

function base64DecToArr(sBase64, nBlockSize) {

    var
        sB64Enc = sBase64.replace(/[^A-Za-z0-9\+\/]/g, ""), nInLen = sB64Enc.length,
        nOutLen = nBlockSize ? Math.ceil((nInLen * 3 + 1 >>> 2) / nBlockSize) * nBlockSize : nInLen * 3 + 1 >>> 2,
        aBytes = new Uint8Array(nOutLen);

    for (var nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
        nMod4 = nInIdx & 3;
        nUint24 |= b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
        if (nMod4 === 3 || nInLen - nInIdx === 1) {
            for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
                aBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
            }
            nUint24 = 0;
        }
    }

    return aBytes;
}

/* Base64 string to array encoding */

function uint6ToB64(nUint6) {

    return nUint6 < 26 ?
        nUint6 + 65
        : nUint6 < 52 ?
            nUint6 + 71
            : nUint6 < 62 ?
                nUint6 - 4
                : nUint6 === 62 ?
                    43
                    : nUint6 === 63 ?
                        47
                        :
                        65;

}

function base64EncArr(aBytes) {

    var eqLen = (3 - (aBytes.length % 3)) % 3, sB64Enc = "";

    for (var nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
        nMod3 = nIdx % 3;
        /* Uncomment the following line in order to split the output in lines 76-character long: */
        /*
        if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
        */
        nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
        if (nMod3 === 2 || aBytes.length - nIdx === 1) {
            sB64Enc += String.fromCharCode(uint6ToB64(nUint24 >>> 18 & 63), uint6ToB64(nUint24 >>> 12 & 63), uint6ToB64(nUint24 >>> 6 & 63), uint6ToB64(nUint24 & 63));
            nUint24 = 0;
        }
    }

    return eqLen === 0 ?
        sB64Enc
        :
        sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");

}


export default EncryptionService;